// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__1GLkt","settings":"Controls_settings__FW6H-","btns":"Controls_btns__2yf3u"};